export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10807.8586b5a5.jpg";